
import UploadPictureComponent from "@/components/RegisterTest/UploadPicture/UploadPictureComponent";
export default UploadPictureComponent;
